var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 177.963,
    height: 152.002,
    viewBox: "0 0 177.963 152.002",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_976",
    "data-name": "Rectangle 976",
    width: 177.963,
    height: 152.002,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_179",
    "data-name": "Group 179",
    transform: "translate(0.001)",
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_761",
    "data-name": "Path 761",
    d: "M227.786,216.889l-56.712,28.735,53.083,20.1,56.712-28.735Z",
    transform: "translate(-136.991 -175.426)",
    fill: "#ecebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_762",
    "data-name": "Path 762",
    d: "M508.8,236.992l-53.083-20.1v47Z",
    transform: "translate(-364.926 -175.426)",
    fill: "#d4d3d2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_763",
    "data-name": "Path 763",
    d: "M437.512,350.779v61.51l56.711-28.735v-61.51Z",
    transform: "translate(-350.345 -260.478)",
    fill: "#ffe8da"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_764",
    "data-name": "Path 764",
    d: "M437.512,350.779v61.51l56.711-28.735v-61.51Z",
    transform: "translate(-350.345 -260.478)",
    fill: "#d3edf5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_178",
    "data-name": "Group 178",
    transform: "translate(-0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_177",
    "data-name": "Group 177",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_765",
    "data-name": "Path 765",
    d: "M436.711,411.671a.206.206,0,0,1-.1-.027.19.19,0,0,1-.1-.164V349.97a.19.19,0,0,1,.106-.169l56.712-28.735a.207.207,0,0,1,.2.005.19.19,0,0,1,.1.164v61.51a.19.19,0,0,1-.106.169L436.8,411.649a.206.206,0,0,1-.093.022m.2-61.586v61.077l56.313-28.533V321.553Zm56.512,32.66h0Z",
    transform: "translate(-349.544 -259.669)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_766",
    "data-name": "Path 766",
    d: "M91.6,167.119,34.886,195.854,1,184.09l56.711-28.735Z",
    transform: "translate(-0.802 -125.656)",
    fill: "#e1f4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_767",
    "data-name": "Path 767",
    d: "M34.084,195.236a.2.2,0,0,1-.068-.011L.131,183.461A.193.193,0,0,1,0,183.295a.19.19,0,0,1,.106-.182l56.712-28.735a.206.206,0,0,1,.161-.011L90.863,166.13a.192.192,0,0,1,.131.167.19.19,0,0,1-.106.182L34.177,195.214a.2.2,0,0,1-.093.022M.69,183.249l33.378,11.588L90.3,166.343,56.926,154.755Z",
    transform: "translate(0 -124.847)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_768",
    "data-name": "Path 768",
    d: "M528.108,333.808,471.4,362.543l-33.884-11.764,56.711-28.735Z",
    transform: "translate(-350.345 -260.478)",
    fill: "#e1f4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_769",
    "data-name": "Path 769",
    d: "M470.595,361.925a.2.2,0,0,1-.068-.011L436.642,350.15a.192.192,0,0,1-.131-.167.19.19,0,0,1,.106-.182l56.712-28.735a.2.2,0,0,1,.161-.011l33.885,11.764a.192.192,0,0,1,.131.167.19.19,0,0,1-.106.182L470.688,361.9a.2.2,0,0,1-.093.022M437.2,349.937l33.378,11.588,56.235-28.494-33.378-11.588Z",
    transform: "translate(-349.543 -259.669)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_770",
    "data-name": "Path 770",
    d: "M171.074,428.708l53.083,20.1V387.3l-53.083-20.1Z",
    transform: "translate(-136.991 -297)",
    fill: "#bae4ee"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_771",
    "data-name": "Path 771",
    d: "M223.358,448.193a.206.206,0,0,1-.073-.013l-53.083-20.1a.191.191,0,0,1-.126-.178v-61.51a.189.189,0,0,1,.087-.158.206.206,0,0,1,.185-.02l53.083,20.1a.192.192,0,0,1,.126.178V448a.19.19,0,0,1-.087.158.205.205,0,0,1-.112.033m-52.884-20.424,52.685,19.952v-61.1L170.473,366.67Z",
    transform: "translate(-136.19 -296.191)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_772",
    "data-name": "Path 772",
    d: "M50.9,367.2,21,382.472l53.083,20.1,29.9-15.274Z",
    transform: "translate(-16.813 -297)",
    fill: "#e1f4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_773",
    "data-name": "Path 773",
    d: "M73.279,401.958a.207.207,0,0,1-.073-.013l-53.083-20.1a.188.188,0,0,1-.021-.347L50,366.221a.207.207,0,0,1,.167-.009l53.083,20.1a.192.192,0,0,1,.126.167.19.19,0,0,1-.105.18l-29.9,15.274a.207.207,0,0,1-.093.022M20.67,381.638l52.6,19.918,29.439-15.038L50.109,366.6Z",
    transform: "translate(-16.012 -296.192)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_774",
    "data-name": "Path 774",
    d: "M485.622,136.993l-29.9,15.274,53.083,20.1,29.9-15.274Z",
    transform: "translate(-364.926 -110.804)",
    fill: "#e1f4fd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_775",
    "data-name": "Path 775",
    d: "M508,171.752a.207.207,0,0,1-.073-.013l-53.083-20.1a.188.188,0,0,1-.021-.347l29.9-15.274a.207.207,0,0,1,.167-.009l53.084,20.1a.192.192,0,0,1,.126.167.19.19,0,0,1-.105.18L508.1,171.73a.205.205,0,0,1-.094.023M455.4,151.433l52.6,19.918,29.439-15.038-52.6-19.918Z",
    transform: "translate(-364.125 -109.995)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_776",
    "data-name": "Path 776",
    d: "M454.92,172.052a.2.2,0,0,1-.15-.065.186.186,0,0,1,.019-.27s.3-.255.784-.7a.205.205,0,0,1,.282.006.186.186,0,0,1-.006.27c-.489.448-.785.7-.8.708a.2.2,0,0,1-.131.047",
    transform: "translate(-364.125 -138.283)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M429.242,58.527a.2.2,0,0,1-.137-.053.186.186,0,0,1-.007-.27c.5-.5.978-1.013,1.434-1.521a.2.2,0,0,1,.281-.02.186.186,0,0,1,.021.27c-.46.513-.946,1.029-1.447,1.535a.2.2,0,0,1-.144.06m2.8-3.125a.205.205,0,0,1-.121-.04.186.186,0,0,1-.036-.268c.448-.56.865-1.119,1.242-1.663a.2.2,0,0,1,.276-.054.186.186,0,0,1,.056.265c-.381.551-.8,1.118-1.258,1.685a.2.2,0,0,1-.158.075m2.359-3.436a.2.2,0,0,1-.095-.023.187.187,0,0,1-.08-.259,16.193,16.193,0,0,0,.9-1.842.2.2,0,0,1,.258-.109.189.189,0,0,1,.113.248,16.535,16.535,0,0,1-.92,1.885.2.2,0,0,1-.175.1M427,48.292a.2.2,0,0,1-.2-.173.193.193,0,0,1,.179-.209,6.666,6.666,0,0,0,2-.512.2.2,0,0,1,.263.1.188.188,0,0,1-.1.252,7.085,7.085,0,0,1-2.124.543H427m-2.13-.135a.206.206,0,0,1-.044,0q-.21-.046-.423-.1a6.2,6.2,0,0,1-1.611-.708.187.187,0,0,1-.059-.264.2.2,0,0,1,.275-.057,5.8,5.8,0,0,0,1.5.662q.2.056.4.1a.191.191,0,0,1,.15.229.2.2,0,0,1-.194.149m11.047-.027a.217.217,0,0,1-.038,0,.192.192,0,0,1-.158-.224,7.585,7.585,0,0,0,.157-1.5c0-.168-.006-.335-.019-.5a.2.2,0,0,1,.4-.029c.014.171.02.348.02.525a7.964,7.964,0,0,1-.165,1.573.2.2,0,0,1-.2.155m-5.046-1.46a.2.2,0,0,1-.153-.068.186.186,0,0,1,.025-.269,8.8,8.8,0,0,0,1.432-1.466.2.2,0,0,1,.279-.039.186.186,0,0,1,.041.267,9.182,9.182,0,0,1-1.5,1.531.2.2,0,0,1-.128.045m-9.545-.684a.2.2,0,0,1-.157-.073,6.42,6.42,0,0,1-1.065-1.847.189.189,0,0,1,.121-.244.2.2,0,0,1,.254.116,6.135,6.135,0,0,0,1,1.739.186.186,0,0,1-.033.268.2.2,0,0,1-.123.041M435.538,44.1a.2.2,0,0,1-.182-.113,5.932,5.932,0,0,0-1.161-1.641.186.186,0,0,1,.008-.27.205.205,0,0,1,.282.007,6.317,6.317,0,0,1,1.235,1.747.188.188,0,0,1-.1.253.2.2,0,0,1-.081.017m-2.114-.693a.2.2,0,0,1-.083-.018.188.188,0,0,1-.1-.254,10.042,10.042,0,0,0,.692-1.905.2.2,0,0,1,.24-.141.191.191,0,0,1,.147.231,10.4,10.4,0,0,1-.717,1.976.2.2,0,0,1-.181.111m-13.448-1.234h-.014a.194.194,0,0,1-.185-.2,3.57,3.57,0,0,1,.766-2.008.2.2,0,0,1,.279-.034.186.186,0,0,1,.035.268,3.155,3.155,0,0,0-.683,1.8.2.2,0,0,1-.2.178m12.7-1.061a.206.206,0,0,1-.107-.03,13.154,13.154,0,0,0-1.87-.935.188.188,0,0,1-.105-.251.2.2,0,0,1,.262-.1,13.6,13.6,0,0,1,1.929.964.187.187,0,0,1,.061.264.2.2,0,0,1-.168.088m-3.917-1.644a.208.208,0,0,1-.057-.008,19.131,19.131,0,0,0-2.061-.48.192.192,0,0,1-.161-.222.2.2,0,0,1,.231-.155,19.543,19.543,0,0,1,2.106.49.19.19,0,0,1,.133.238.2.2,0,0,1-.191.136m5.657-.037h-.007a.2.2,0,0,1-.192-.2q.005-.16.006-.32a8.8,8.8,0,0,0-.162-1.686.192.192,0,0,1,.159-.223.2.2,0,0,1,.232.153,9.164,9.164,0,0,1,.169,1.757q0,.167-.006.333a.2.2,0,0,1-.2.185m-11.981-.317a.2.2,0,0,1-.188-.128.189.189,0,0,1,.122-.244,6.974,6.974,0,0,1,2.173-.33h0a.191.191,0,1,1,0,.382,6.567,6.567,0,0,0-2.044.308.2.2,0,0,1-.066.011m11.183-3.691a.2.2,0,0,1-.182-.113,8.282,8.282,0,0,0-1.082-1.718.186.186,0,0,1,.034-.268.2.2,0,0,1,.28.033,8.667,8.667,0,0,1,1.132,1.8.188.188,0,0,1-.1.253.208.208,0,0,1-.081.017",
    transform: "translate(-336.143 -26.919)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_778",
    "data-name": "Path 778",
    d: "M471.727,23.346a.2.2,0,0,1-.125-.042c-.269-.208-.557-.409-.857-.6a.187.187,0,0,1-.058-.265.2.2,0,0,1,.276-.056,10.828,10.828,0,0,1,.89.619.186.186,0,0,1,.03.269.2.2,0,0,1-.155.071",
    transform: "translate(-376.883 -18.082)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_779",
    "data-name": "Path 779",
    d: "M446.782,15.724c-.938,0-1.7-.558-1.7-1.244s.763-1.244,1.7-1.244,1.7.558,1.7,1.244-.763,1.244-1.7,1.244m0-2.105c-.718,0-1.3.386-1.3.861s.584.862,1.3.862,1.3-.387,1.3-.862-.584-.861-1.3-.861",
    transform: "translate(-356.406 -10.706)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_780",
    "data-name": "Path 780",
    d: "M455.45,5.343a.579.579,0,0,1-.3-.081c-.411-.248-.377-.959.079-1.654s1.11-1.033,1.52-.786a.707.707,0,0,1,.279.726,2.165,2.165,0,0,1-.358.929,1.673,1.673,0,0,1-1.217.867m.993-2.219a1.352,1.352,0,0,0-.879.687c-.359.547-.361,1.033-.2,1.127s.612-.118.97-.665a1.816,1.816,0,0,0,.3-.763c.018-.182-.017-.318-.095-.365a.175.175,0,0,0-.091-.022m.055,1.251h0Z",
    transform: "translate(-364.236 -2.217)",
    fill: "#3cafe6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_781",
    "data-name": "Path 781",
    d: "M450.248,2.878a.775.775,0,0,1-.633-.425,2.152,2.152,0,0,1-.289-.951A2.133,2.133,0,0,1,449.46.52a.742.742,0,0,1,.6-.518.753.753,0,0,1,.675.423,2.15,2.15,0,0,1,.289.951,2.136,2.136,0,0,1-.133.982.743.743,0,0,1-.6.518l-.042,0M450.1.383h-.01c-.092.007-.189.112-.261.28a1.789,1.789,0,0,0-.105.809,1.8,1.8,0,0,0,.233.783c.1.157.215.245.3.239s.189-.112.261-.28a1.789,1.789,0,0,0,.105-.808h0a1.8,1.8,0,0,0-.233-.783c-.094-.151-.2-.239-.293-.239",
    transform: "translate(-359.798 -0.001)",
    fill: "#3cafe6"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no-data.db5ff39a67444b58ef600ab50596690e.svg";
export { ForwardRef as ReactComponent };